import Video from 'components/Video';
import MapViewer from 'layout/MapViewer';
import Paranoma from 'layout/Paranoma';
import { ControlContext } from 'provider/ControlProvider';
import { useContext, useEffect } from 'react';
import { useAudioPlayer } from 'react-use-audio-player';

export default function Configurator() {
  const { content, controlStatus, prepare } = useContext(ControlContext);
  const startSound = useAudioPlayer();
  const envSound = useAudioPlayer();
  useEffect(() => {
    startSound.load('/music/adver.mp3', { autoplay: false });
    envSound.load('/music/main.mp3', { autoplay: false, loop: true });
  }, []);

  useEffect(() => {
    if (content.type === 0) {
      if (prepare) {
        envSound.play();
        startSound.stop();
      } else if (controlStatus) {
        startSound.play();
      }
    } else {
      envSound.stop();
      startSound.stop();
    }
  }, [controlStatus, content, prepare]);
  return (
    <div className={'h-screen w-screen fixed ios '}>
      {/* <div className='absolute bottom-5 right-5 bg-black z-50 p-7 text-white font-bold'>
        <h2>Made By</h2>
        <p>evgeniipetrukhin90@gmail.com</p>
      </div> */}
      {content.type === 3 && <Video url={content.url} />}
      {content.type === 1 && content.index > 0 && <Paranoma />}
      <MapViewer />
    </div>
  );
}
